import { render, staticRenderFns } from "./BusinessRelationshipComponent.vue?vue&type=template&id=19fe1c28"
import script from "./BusinessRelationshipComponent.vue?vue&type=script&lang=js"
export * from "./BusinessRelationshipComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports